.submit {
    color: #ffffff;
    background-color: #ffa489;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border-radius: 0;
    height: auto;
    padding: var(--space-3) var(--space-5);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.submit:hover:not(:disabled) {
    background-color: #ffffff;
    color: black;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.15);
}

.submit:disabled {
    opacity: 0.7;
    cursor: wait;
}

.honeypot {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}
